import * as actionTypes from "Consts/actionsTypes";

const defaultState = {
	show: false,
};

export const mobileMenu = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.MAIN_MENU__TOGGLE:
			state = {
				...state,
				show: action.payload.show,
			};
			break;
	}
	return state;
};
